export default __webpack_public_path__ + "static/media/student-login.84580469.svg";